import { Box, Paper, SxProps, Theme, Typography } from '@mui/material';

export interface ContentSectionProps {
  title: string;
  children: React.ReactNode;
  elevation?: number;
  sx?: SxProps<Theme>;
}

export const ContentSection: React.FC<ContentSectionProps> = ({ title, children, elevation, sx }) => {
  return (
    <Paper
      elevation={elevation ?? 0}
      sx={{
        border: '1px solid',
        borderColor: 'grey.300',
        borderRadius: 1,
        p: { xs: 2, md: 3 },
        mb: 3,
        ...sx,
      }}
    >
      <Typography variant="h4" component="h2" mb={2} fontSize={{ xs: 20, md: 22 }}>
        {title}
      </Typography>
      <Box>{children}</Box>
    </Paper>
  );
};
